import { TechRadarLoaderResponse } from '@backstage-community/plugin-tech-radar';

interface DefaultRing {
  id: string;
  name: string;
  color: string;
}

interface DefaultQuadrant {
  id: string;
  name: string;
}

interface DefaultTimeline {
  moved: number;
  ringId: string;
  date: string;
  description?: string;
}

interface DefaultEntry {
  id: string;
  key: string;
  title: string;
  description: string;
  url: string;
  quadrant: string;
  timeline: DefaultTimeline[];
}

interface DefaultRadarResponse {
  rings: DefaultRing[];
  quadrants: DefaultQuadrant[];
  entries: DefaultEntry[];
}

export const handle = (data: DefaultRadarResponse): TechRadarLoaderResponse => {
  const quadrants = data.quadrants.map(quadrant => {
    return {
      id: quadrant.id,
      name: quadrant.name,
    };
  });

  const rings = data.rings.map(ring => {
    return {
      id: ring.id,
      name: ring.name,
      color: ring.color,
    };
  });

  const entries = data.entries.map(entity => {
    return {
      timeline: entity.timeline.map(timeline => {
        return {
          moved: timeline.moved,
          ringId: timeline.ringId.toLowerCase(),
          date: new Date(timeline.date),
          description: timeline.description,
        };
      }),
      url: entity.url,
      key: entity.key,
      id: entity.id,
      title: entity.title,
      quadrant: entity.quadrant,
      description: entity.description,
    };
  });

  return {
    quadrants: quadrants,
    rings: rings,
    entries: entries,
  };
};
